'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Request = require('./request').default;
var Service = require('./service').default;
var Location = require('./location').default;
var validator = require('validator');
var Response = require('./response').default;
var Radio = require('backbone.radio');
var moment = require('moment-timezone');
var urls = require('../utilities/urls').default;
var Utils = require('../utilities/Utilities').default;
var calendar = require('../utilities/calendar').default;
var polyglot = require('../utilities/polyglot').default;
var Questions = require('../collections/questions').default;
var FormQuestions = require('../collections/form-questions').default;
var LanguageCollection = require('../collections/languages').default;
var ResponseCollection = require('../collections/responses').default;
var AttendeeResponseCollection = require('../collections/attendee-responses').default;

export default Backbone.Model.extend({

  defaults: {
    client_view_request: true,
    client: [{}],
    service_id: [],
    timezone: 'America/Regina',
    timezone_abbr: 'CST',
    type: 0,
    booked_through: window.CONSTANTS.ORIGIN_CLIENT_VIEW,
    timezone_proper: true,
  },

  initialize: function () {
    this.services = this.get('services') ? _.map(this.get('services'), function (service) {
      return new Service(service);
    }) : [];
    this.staff = this.get('staff') ? new Backbone.Model(this.get('staff')) : null;
    this.location = this.get('location') ? new Location(this.get('location')) : null;
  },

  url: function () {
    var url = '/online_bookings/ajax_appointments';
    if (this.id) {
      url += '/' + this.id;
    }

    return url + '?lang=' + (new LanguageCollection()).getCurrent();
  },

  rescheduleUrl: function () {
    var url = '/online_bookings/ajax_reschedule_appointment';

    return url + '?lang=' + (new LanguageCollection()).getCurrent();
  },

  parse: function (response) {
    return response.data.appointment[0];
  },

  hasLocation: function () {
    return this.has('location');
  },

  getLocation: function () {
    return this.location;
  },

  setLocation: function (location) {
    this.location = location;
    this.set('location_id', location.id);
    this.setTimezone(location.get('timezone'), location.get('timezone_abbr'));
  },

  unsetLocation: function () {
    this.location = null;
    this.unset('location_id');
    this.setTimezone(this.defaults.timezone, this.defaults.timezone_abbr);
  },

  hasPreferredLocation: function () {
    return this.has('preferred_location');
  },

  getPreferredLocation: function () {
    return this.get('preferred_location');
  },

  setPreferredLocation: function (location) {
    this.preferred_location = location;
  },

  getServices: function () {
    return this.services;
  },

  getNumberOfServices: function () {
    return this.services.length;
  },

  getServiceNames: function () {
    var names = [];
    _.each(this.getServices(), function (service) {
      names.push(service.get('name'));
    });

    return names;
  },

  canAddService: function (service) {
    var first = this.getFirstService();
    if (!first) {
      return true;
    }
    if (window.SETTINGS.single_service_selection) {
      return false;
    }

    if (first.get('group_service')) {
      return false;
    }

    if (service.get('group_service')) {
      return false;
    }

    if (service.get('destination') !== first.get('destination')) {
      return false;
    }

    return true;
  },

  addService: function (service) {
    var service_ids = _.clone(this.get('service_id'));

    if (!_.contains(service_ids, service.id)) {
      service_ids.push(service.id);
      this.services.push(service);

      this.set('service_id', service_ids);
    }

    if (service.get('destination') == 2) {
      this.timezoneFromCookie();
    }

    this.setupResponses();
  },

  setTimezone: function (timezone, timezone_abbr) {
    this.set('timezone', timezone);
    this.set('timezone_abbr', timezone_abbr);
  },

  timezoneFromCookie: function () {
    if (window.localStorage.getItem('timezone')) {
      var timezone = window.localStorage.getItem('timezone');
      this.setTimezone(timezone, moment.tz(timezone)
        .zoneAbbr());
    } else {
      this.set('timezone_proper', false);
    }
  },

  removeService: function (service) {
    var service_ids = _.clone(this.get('service_id'));

    service_ids = _.without(service_ids, service.id);
    this.services = _.without(this.services, _.findWhere(this.services, {
      id: service.id,
    }));

    this.set('service_id', service_ids);

    this.setupResponses();
  },

  hasService: function (service) {
    return _.contains(this.get('service_id'), service.id);
  },

  unsetServices: function () {
    this.set('service_id', []);
    this.services = [];
  },

  hasServices: function () {
    if (!this.has('service_id')) {
      return false;
    }

    var service_id = this.get('service_id');
    return service_id.length > 0;
  },

  getFirstService: function () {
    if (!this.services || this.services.length === 0) {
      return false;
    }

    return this.services[0];
  },

  getFirstServiceId: function () {
    var service = this.getFirstService();
    if (!service) {
      return null;
    }

    return service.get('id');
  },

  setupResponses: function () {
    var questions = new Questions(window.QUESTIONS);

    if (questions.isEmpty()) {
      return true;
    }

    var apptServiceIds    = this.get('service_id'),
        added             = [],
        responses         = [],
        attendeeResponses = [];

    questions.each(function (question) {
      if (question.isValid() && question.hasServices(apptServiceIds)) {
        if (!_.contains(added, question.get('id'))) {
          added.push(question.get('id'));
          responses.push(new Response({ question }));
          attendeeResponses.push(new Response({ question }));
        }
      }
    });

    this.responses = new ResponseCollection(responses, this);
    this.attendeeResponses = new AttendeeResponseCollection(attendeeResponses, this);
  },

  getStaff: function () {
    return this.staff;
  },

  setStaff: function (staff) {
    this.staff = staff;
    this.set('staff_id', staff.id);
    this.set('staff', staff);
    this.staff = staff;
  },

  unsetStaff: function () {
    this.staff = null;
    this.unset('staff_id');
    this.unset('staff');
    this.staff = null;
  },

  isGroup: function () {
    var service = this.getFirstService();
    if (!service) {
      return false;
    }

    return service.get('group_service');
  },

  isDisplayInLobbyEnabled: function() {
    var service = this.getFirstService();
    if (!service) {
      return false;
    }

    return service.get('display_in_lobby');
  },

  isHere: function () {
    var service = this.getFirstService();
    if (!service) {
      return false;
    }

    return service.get('destination') === window.CONSTANTS.SERVICE_DESTINATION_HERE;
  },

  isAway: function () {
    var service = this.getFirstService();
    if (!service) {
      return false;
    }
    return service.get('destination') === window.CONSTANTS.SERVICE_DESTINATION_AWAY;
  },

  isRemote: function () {
    var service = this.getFirstService();
    if (!service) {
      return false;
    }

    return service.get('destination') === window.CONSTANTS.SERVICE_DESTINATION_REMOTE;
  },

  isVirtual: function () {
    return this.location.isVirtual();
  },

  showLocationInformation: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.location_information !== 'na';
  },

  showHomePhone: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.phone !== 'na';
  },

  showMobilePhone: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.mobile_phone !== 'na';
  },

  showWorkPhone: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.work_phone !== 'na';
  },

  showNotes: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.notes !== 'na';
  },

  isLocationInformationRequired: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.location_information === 'required';
  },

  isHomePhoneRequired: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.phone === 'required';
  },

  isMobilePhoneRequired: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.mobile_phone === 'required';
  },

  isWorkPhoneRequired: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.work_phone === 'required';
  },

  isNotesRequired: function () {
    return window.SETTINGS.client_fields !== null &&
           window.SETTINGS.client_fields.notes === 'required';
  },

  isSmsEnabled: function () {
    return window.SETTINGS.enable_sms;
  },

  isCreditCardEnabled: function () {
    return window.SETTINGS.credit_card_capture;
  },

  cancelEnabled: function () {
    return window.SETTINGS.cancellation_allowance >= 0;
  },

  rescheduleEnabled: function () {
    return window.SETTINGS.reschedule_allowance >= 0;
  },

  canCancel: function (previousStart = null) {
    if (!this.cancelEnabled() || this.get('rrule_summary')) {
      return false;
    }

    var timezone = this.location.get('timezone');
    var deadline = moment.tz(timezone)
      .add(window.SETTINGS.cancellation_allowance, 'minutes');
    var start = moment.tz(previousStart ? previousStart : this.get('start'), timezone);

    if (start.isBefore(deadline)) {
      return false;
    }

    // if we can't create the cancel link, then we can't cancel
    if (!this.getCancelLink()) {
      return false;
    }

    return true;
  },

  canReschedule: function () {
    if (!this.rescheduleEnabled() || this.get('rrule_summary')) {
      return false;
    }

    var timezone = this.location.get('timezone');
    var deadline = moment.tz(timezone)
      .add(window.SETTINGS.reschedule_allowance, 'minutes');
    var start = moment.tz(this.get('start'), timezone);

    if (start.isBefore(deadline)) {
      return false;
    }

    return true;
  },

  getCancelLink: function () {
    if (!this.has('clients') && !this.has('client')) {
      return null;
    }

    var client = this.get('clients') && this.get('clients')[0] || this.get('client')[0];
    if (!client) {
      return null;
    }

    var link = '/details?confirm_code=' + (client.AppointmentClient
                                           && client.AppointmentClient.confirm_code
                                           || client.appointmentclient.confirm_code);
    link += '&cid=' + client.id;

    var lang = urls.param('lang');

    if (lang) {
      link += '&lang=' + lang;
    }

    return link;
  },

  isPrivate: function () {
    var location = this.getLocation(),
        staff    = this.getStaff();

    if (location && location.backend_only) {
      return true;
    }

    if (staff && staff.backend_only) {
      return true;
    }

    if (this.hasPrivateService()) {
      return true;
    }

    return false;
  },

  isInviteOnly: function () {
    if (this.has('service')) {
      var service = this.get('service');

      return service.visibility ===
             window.CONSTANTS.SERVICE_VISIBILITY_INVITE_ONLY;
    }

    return _.any(this.getServices(), function (service) {
      return service.get('visibility') ===
             window.CONSTANTS.SERVICE_VISIBILITY_INVITE_ONLY;
    });
  },

  hasPrivateService: function () {
    if (this.has('service')) {
      var service = this.get('service');

      return service.visibility ===
             window.CONSTANTS.SERVICE_VISIBILITY_PRIVATE;
    }

    return _.any(this.services, function (service) {
      return service.visibility ===
             window.CONSTANTS.SERVICE_VISIBILITY_PRIVATE;
    });
  },

  createRequest: function () {
    var request = new Request({
      location_id: this.get('location_id'),
    });

    if (this.getNumberOfServices() === 1) {
      request.set('service_id', this.getFirstServiceId());
    } else if (!window.SETTINGS.advanced_wait_list) {
      request.set('request', this.getServiceNames()
        .join('\n'));
    }

    if (window.SETTINGS.advanced_wait_list) {
      var staffId = window.SETTINGS.show_staff_picker || window.STAFF
                    ? this.get('staff_id')
                    : null;
      request.set('staff_id',
        String(!window.SETTINGS.enable_builder && staffId ? staffId : 'null'));
      request.set('location', this.getLocation()
        .toJSON());
      request.timezoneAbbr = this.getTimezoneAbbr();
      request.timezone = this.getTimezone();

      var services = this.getServices();
      if (services) {
        var service = services[0].toJSON();
        request.set('service', service);
        request.set('service_id', service.id);
        request.multiService = services.length > 1;
      }
    }

    return request;
  },

  createEvent: function () {
    var evt = {
      start: this.get('start'),
      end: this.get('client_end'),
      timezone: this.location.get('timezone'),
    };

    var location = this.getLocation();
    if (this.isHere() && location) {
      evt.location = location.getFullAddress();
    }

    var service = this.getFirstService();
    var services = this.getServices();
    var staff = this.getStaff();

    var name;
    if (staff) {
      name = staff.get('full_name') + ' (' + window.SETTINGS.vendor_name + ')';

      if (!_.isEmpty(window.THEME.provider)) {
        name = window.THEME.provider;
      }
    }

    if (service && staff) {
      evt.title = service.get('name') + ' ' + polyglot.t('appointment.with') +
                  ' ' + name;
    } else if (service) {
      evt.title = service.get('name') + ' (' + window.SETTINGS.vendor_name +
                  ')';
    } else if (staff) {
      evt.title = polyglot.t('appointment.appointment') + ' ' + polyglot.t('appointment.with') + ' '
                  + name;
    } else {
      evt.title = polyglot.t('appointment.appointment') + ' (' + window.SETTINGS.vendor_name + ')';
    }

    var cancelLink = window.location.protocol + '//' + window.location.host;

    if (window.location.pathname.indexOf('/b') > -1) {
      cancelLink += window.location.pathname;
    }

    cancelLink += this.getCancelLink();

    var description = '';
    _.map(services, function (service) {
      if (service.get('instructions') !== null) {
        description += service.get('name') + ' - ' +
                       service.get('instructions') +
                       '\n\n';
      }
    });
    description += polyglot.t('appointment.to_cancel_appointment', { link: cancelLink });

    evt.description = description;

    return evt;
  },

  getGoogleLink: function () {
    return calendar.google(this.createEvent());
  },

  getYahooLink: function () {
    return calendar.yahoo(this.createEvent());
  },

  getOutlookLink: function () {
    return calendar.outlook(this.createEvent());
  },

  getICalLink: function () {
    return calendar.ical(this.get('appointmentclient')[0]);
  },

  validate: function (attrs, options) {
    if (options.step == polyglot.t('pages.locations.slug')) {
      return this.validateLocationStep(attrs, options);
    }

    if (options.step == polyglot.t('pages.services.slug')) {
      return this.validateServiceStep(attrs, options);
    }

    if (options.step == polyglot.t('pages.times.slug')) {
      return this.validateTimeStep(attrs, options);
    }

    if (options.step == polyglot.t('pages.cancel.slug')) {
      return this.validateCancelStep(attrs, options);
    }

    if (options.step == polyglot.t('pages.reschedule.slug')) {
      return this.validateRescheduleStep(attrs, options);
    }

    return this.validateDetailsStep(attrs, options);
  },

  validateLocationStep: function (attrs, options) {
    var errors = {};
    var previousStep = Radio.channel('steps')
      .request('previous', polyglot.t('pages.locations.slug'));
    if (previousStep) {
      errors = _.extend({}, this.validateServiceStep(attrs, options));
    }

    if (!attrs.location_id) {
      errors.toast = polyglot.t('appointment.validation.location_id');
    }

    if (_.size(errors)) {
      return errors;
    }
  },

  validateServiceStep: function (attrs, options) {
    var errors = {};
    var previousStep = Radio.channel('steps')
      .request('previous', polyglot.t('pages.services.slug'));
    if (previousStep) {
      errors = _.extend({}, this.validateLocationStep(attrs, options));
    }

    if (!attrs.service_id || attrs.service_id.length === 0) {
      errors.toast = polyglot.t('appointment.validation.service_id');
    }

    if (_.size(errors)) {
      return errors;
    }
  },

  validateTimeStep: function (attrs, options) {
    var previousStep = Radio.channel('steps')
      .request('previous', polyglot.t('pages.times.slug'));
    var errors = {};
    if (previousStep) {
      if (previousStep.get('slug') === polyglot.t('pages.locations.slug')) {
        errors = _.extend({}, this.validateServiceStep(attrs, options));
      } else if (previousStep.get('slug') === polyglot.t('pages.services.slug')) {
        errors = _.extend({}, this.validateLocationStep(attrs, options));
      }
    }

    if (!window.SETTINGS.enable_builder) {
      if (!attrs.staff_id && attrs.type !== window.CONSTANTS.APPT_TYPE_CLIENT_GROUP) {
        errors.toast = polyglot.t('appointment.validation.staff_id');
      }
    }

    if (!attrs.start) {
      errors.toast = polyglot.t('appointment.validation.start');
    }

    if (_.size(errors)) {
      return errors;
    }
  },

  validateDetailsStep: function (attrs, options) {
    var errors = _.extend({}, this.validateTimeStep(attrs, options));
    var client = attrs.client[0];
    var appointmentClient = client.appointmentclient;

    if (!client.first_name) {
      errors.first_name = polyglot.t('forms.first_name.error');
    } else {
      if (client.first_name.match(Utils.SPECIAL_CHARS)) {
        errors.first_name = polyglot.t('forms.first_name.error.chars');
      }
    }

    if (!client.last_name) {
      errors.last_name = polyglot.t('forms.last_name.error');
    } else {
      if (client.last_name.match(Utils.SPECIAL_CHARS)) {
        errors.last_name = polyglot.t('forms.last_name.error.chars');
      }
    }

    if (!(client.email && validator.isEmail(client.email))) {
      errors.email = polyglot.t('forms.email.error');
    }

    if (appointmentClient && this.isNotesRequired() && !appointmentClient.notes) {
      errors.notes = polyglot.t('forms.notes.error');
    }

    //limited client data is sent back from the server, so certain client fields
    //can't be validated once there is a client.id
    if (!client.id) {
      if (this.isMobilePhoneRequired() && !client.cell_phone) {
        errors.cell_phone = polyglot.t('forms.cell_phone.error');
      }

      if (client.cell_phone && client.cell_phone.match(/[A-z]/g)) {
        errors.cell_phone = polyglot.t('forms.cell_phone.error');
      }

      if (this.isHomePhoneRequired() && !client.phone) {
        errors.home_phone = polyglot.t('forms.cell_phone.error');
      }

      if (client.phone && client.phone.match(/[A-z]/g)) {
        errors.home_phone = polyglot.t('forms.cell_phone.error');
      }

      if (this.isWorkPhoneRequired() && !client.work_phone) {
        errors.work_phone = polyglot.t('forms.cell_phone.error');
      }

      if (client.work_phone && client.work_phone.match(/[A-z]/g)) {
        errors.work_phone = polyglot.t('forms.cell_phone.error');
      }

      if (this.isAway()) {
        if (!client.appt_address) {
          errors.appt_address = polyglot.t('forms.address.error');
        }

        if (!client.appt_city) {
          errors.appt_city = polyglot.t('forms.appt_city.error');
        }
      }

      if (this.isLocationInformationRequired()) {
        if (!client.address) {
          errors.address = polyglot.t('forms.address.error');
        }

        if (!client.city) {
          errors.city = polyglot.t('forms.city.error');
        }

        if (!client.zip_postal) {
          errors.zip_postal = polyglot.t('forms.zip_postal.error');
        }

        if (!client.country) {
          errors.country = polyglot.t('forms.country.error');
        }

        //if the prov/state isn't set AND the country is set AND the country is USA OR Canada, set
        // the error
        if (!client.prov_state && (client.country && (client.country == 'CA' || client.country == 'US'))) {
          errors.prov_state = polyglot.t('forms.prov_state.error');
        }
      }
    }

    if (_.size(this.responses) > 0) {
      var required = _.filter(this.responses.models, function (response) {
        return response.get('question')
          .get('required');
      });

      if (_.size(required) > 0) {
        var answers = [];
        if (attrs.answers) {
          answers = attrs.answers;
        }

        _.each(required, function (q) {
          var question = q.get('question');

          if (!answers[question.get('id')]) {
            errors[question.get('id')] = polyglot.t('forms.required.error');
          }
        });
      }
    }

    if (_.size(errors)) {
      return errors;
    }
  },

  validateRescheduleStep: function (attrs, options) {
    var errors = {};

    if (!attrs.start || attrs.start === options.originalStart) {
      errors.toast = polyglot.t('appointment.validation.reschedule_start');
    }

    if (_.size(errors)) {
      return errors;
    }
  },

  validateCancelStep: function (attrs, options) {
    var errors = {};

    if (this.isNotesRequired() && (!options.notes || options.notes === '')) {
      errors.notes = polyglot.t('forms.notes.error');
    }

    if (_.size(errors)) {
      return errors;
    }
  },

  isValidAppointment: function () {
    var client = this.get('clients')[0];
    return Backbone.ajax({
      method: 'GET',
      url: '/online_bookings/ajax_appointments',
      data: {
        confirm_code: (client.AppointmentClient &&
                       client.AppointmentClient.confirm_code)
                      || client.appointmentclient.confirm_code,
        cid: client.id,
        email: client.email,
      },
    });
  },

  cancel: function (notes) {
    const client = this.get('clients')[0];
    const parameters = {
      client_view_request: true,
      appt_id: this.get('id'),
      confirm_code: client.AppointmentClient
                    && client.AppointmentClient.confirm_code
                    || client.appointmentclient.confirm_code,
      cid: client.id,
      notes: notes,
      _token: $('meta[name="csrf-token"]')
        .attr('content'),
    };

    if (window.CANCEL_FORM) {
      parameters.form_id = window.CANCEL_FORM.id;
      if (window.CANCEL_FORM.questions.length) {
        const formQuestions = new FormQuestions(window.CANCEL_FORM.questions);
        parameters.responses = formQuestions.toResponses();
      }
    }

    return Backbone.ajax({
      method: 'POST',
      url: '/online_bookings/ajax_cancel_appointment?lang=' + (new LanguageCollection()).getCurrent(),
      data: parameters,
    });
  },

  reschedule: function () {
    var client = this.get('clients')[0];
    var appointmentIds = this.isGroup()
                         ? [this.id]
                         : _.map(window.APPOINTMENTS, function(appointment) {
                            return appointment.id;
                         });

    if (typeof this.get('start') !== 'string') {
      var start = this.get('start')
                      .tz(this.getLocation()
                      .get('timezone'))
                      .format('YYYY-MM-DD HH:mm:ss');
      this.set('start', start);
    }

    return Backbone.ajax({
      method: 'POST',
      url: this.rescheduleUrl(),
      data: {
        client_view_request: true,
        is_rescheduling: true,
        id: this.id,
        appt_id: appointmentIds,
        type: this.isGroup() ? 2 : 0,
        confirm_code: client.AppointmentClient && client.AppointmentClient.confirm_code
                      || client.appointmentclient.confirm_code,
        cid: client.id,
        attendee_id: this.get('appointmentclient')[0].id,
        client_timezone: this.get('client_timezone') || null,
        location_id: this.get('location').id,
        service_id: this.get('service_id'),
        staff_id: this.get('staff') ? this.get('staff').id : null,
        start: this.get('start'),
        _token: $('meta[name="csrf-token"]')
          .attr('content'),
      },
    });
  },

  getTimezone: function () {
    var model = this.toJSON();
    var locationTimezone = this.getLocation()
      .get('timezone');
    var timezone;
    if (window.localStorage.getItem('timezone')) {
      timezone = window.localStorage.getItem('timezone');
    } else {
      timezone = locationTimezone;
    }
    var time = typeof model.start !== 'undefined'
               ? model.start : moment()
                 .format('YYYY-MM-DD HH:mm:ss');
    var start = moment.tz(time, timezone);
    start = start.tz(timezone);

    return start.tz();
  },

  getTimezoneAbbr: function () {
    var model = this.toJSON();
    var locationTimezone = this.getLocation()
      .get('timezone');
    var timezone;
    if (window.localStorage.getItem('timezone')) {
      timezone = window.localStorage.getItem('timezone');
    } else {
      timezone = locationTimezone;
    }
    var time = typeof model.start !== 'undefined'
               ? model.start : moment()
                 .format('YYYY-MM-DD HH:mm:ss');
    var start = moment.tz(time, timezone);
    start = start.tz(timezone);

    return start.zoneAbbr();
  },
});
